import React from 'react';
import getRegularHourFormat from '../../Utility/getRegularHourFormat';
import './TimingsComponent.scss';

function Timings() {
  const timings = [];
  for (let hour = 0; hour <= 24; hour += 1) {
    const hourLabel = getRegularHourFormat(hour);
    timings.push(
      <div className="hour-label" key={hour}>
        {hourLabel}
      </div>
    );
  }
  return <div className="hour-labels-container">{timings}</div>;
}

export default Timings;
